/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */
import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import{NgxSpinnerService} from 'ngx-spinner';
import {AccidentClassificationService} from "../../services/accident-classification.service";
import {AccidentClassification} from "../../model/AccidentClassification";
import {NgForm} from "@angular/forms";
import {BaseNgFormAdminComponent} from '../../common/base-ngform-admin.component';

@Component({
    selector: 'app-accident-classification',
    templateUrl: './accident-classification.component.html',
    styleUrls: ['./accident-classification.component.less'],
    standalone: false
})
export class AccidentClassificationComponent extends BaseNgFormAdminComponent implements OnInit {
  public accidentClassifications: AccidentClassification[];

  constructor(private spinnerService: NgxSpinnerService,
              private accidentClassificationService: AccidentClassificationService,
              cdr: ChangeDetectorRef) {
    super(cdr);
  }

  ngOnInit() {
    this.getAllClassifications();
  }

  protected reloadData(): void {
    this.getAllClassifications();
  }

  private getAllClassifications(){
    this.spinnerService.show();
    this.accidentClassificationService.getAll().subscribe(value => {
        this.accidentClassifications = value;
        this.cdr.detectChanges();
      },
      err => {
        this.spinnerService.hide();
        console.log(err);
        alert(err);
      },
      () => {
        this.spinnerService.hide();
      }
    );
  }

  addNew(classification: string){
    this.spinnerService.show();
    var newAccidentClassification = new AccidentClassification();
    newAccidentClassification.classification = classification;

    this.accidentClassificationService.addAccidentClassification(newAccidentClassification).subscribe(retVal=>{
      this.getAllClassifications();
    },(error)=>{
      this.spinnerService.hide();
      if (error.status=='409')
        alert("Duplicate Value(s) found.");
      else
        alert(error.message);
    },()=>{
      this.spinnerService.hide();
      this.returnMessage = 'Adding accident classification finished';
      setTimeout(() => {
        this.returnMessage = '';
      },2000);
    });
  }

  onSubmit(f: NgForm) {
    this.spinnerService.show();
    let count = 0;
    let array = this.getChangedIndex(f);
    var accidentClassificationIds = array.filter(function(elem, index, self) {
      return index == self.indexOf(elem);
    });
    if (accidentClassificationIds!=null && accidentClassificationIds.length>0)
    {
      accidentClassificationIds.forEach(vdi=>{
        var accidentClassificationChanged = this.accidentClassifications.find(x=>x.accidentClassificationId === vdi);
        this.accidentClassificationService.updateAccidentClassificationById(accidentClassificationChanged).subscribe(retValue=>{
          //something here?
        },(error)=>{
          this.spinnerService.hide();
          if (error.status=='409')
            alert("Duplicate Value(s) found.");
          else
            alert(error.message);
          this.returnMessage = '';
          this.getAllClassifications();
          count = 0;
        },()=>{
          count = count + 1;
          if (count>=accidentClassificationIds.length) {
            this.clearNgForm();
            count =0;
            this.spinnerService.hide();
          }
        });
      });
    }
    else{
      this.spinnerService.hide();
      alert("No changes to save.");
    }
  }

  private clearNgForm(){
    this.returnMessage = '';
    this.getAllClassifications();
    this.returnMessage = 'Updating accident classification finished';
    setTimeout(() => {
      this.returnMessage = '';
    }, 2000);
  }

}
